<template>
    <div class="filter-header">
        <div class="filter-header-row">
        <TText :value="`${title}`" />
        <v-spacer></v-spacer>
        <TTooltip value="Your filters" left>
            <ButtonOutlined
                height="16" 
                width="16"
                icon="file"
                @buttonClicked="$emit('openFilterManagement')"
            />
        </TTooltip>
        <TTooltip value="toggle filter" left>
            <ButtonOutlined
                :class="`${filter[type].active? 'grey' : 'side-button'}`"
                height="16" 
                width="16"
                :icon="filter[type].active?'filter-inverted':'filter'"            
                @buttonClicked="toggleFilterLocal({type: type, value: !filter[type].active})"
            />
        </TTooltip>
        </div>
        <div class="filter-header-row">
            <TText :value="`${filtered_items.length} ${type === 'spatial' ? 'elements': 'steps'}`" />
            <v-spacer/>
            <!-- selection -->
            <TTooltip :value="is_selected_result === 'complete' ? 'Remove from selection' : 'Add to Selection' ">
              <TIcon 
                  :name="is_selected_result === 'complete' ? 'checkbox-radial-filled' : is_selected_result === 'part'?'radial-checkbox-dashed':'checkbox-radial-empty'"
                  class="cursor-pointer"
                  @click.native.prevent.stop="setSelectedCollection()"
              />
            </TTooltip>
            <template v-if="type === 'spatial'">
            <!-- visible -->
            <TTooltip value="Set 3D">
              <TIcon
                  name="visiblity-single"
                  class="cursor-pointer"
                  @click.native.prevent.stop="setCollectionObjects({ 
                    action: 'set', 
                    ids_by_target: {elements: filtered_items}, 
                    collection_name: 'visible_elements' 
                  })"
              />
            </TTooltip>
            <!-- visible -->
            <TTooltip :value="is_visible_result === 'complete' ? 'Remove from 3D' : 'Add to 3D' ">
              <TIcon
                :name="is_visible_result === 'complete' ? 'visibility-on' : is_visible_result === 'part'?'visiblity-half':'visibility-off'" 
                class="cursor-pointer"
                @click.native.prevent.stop="setCollectionObjects({
                    action: is_visible_result === 'complete' ? 'remove' : 'add',
                    ids_by_target: {elements: filtered_items},
                    collection_name: type === 'spatial'?'visible_elements':'visible_steps', 
                })"
              />
            </TTooltip>
        </template>
        </div>
    </div>
  </template>
  <script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
    import TIcon from '@/components/Taktify/TIcon.component.vue'
    import TTooltip from '@/components/Taktify/TTooltip.component.vue'

    export default {
      props: ['type', 'title'],
      components: {
        ButtonOutlined,
        TIcon,
        TTooltip,
      },
      data: () => ({
      }),
      computed: {
        ...mapState('ProjectStructure', [
        'filter',
        ]),
        ...mapGetters('ProjectStructure', [
          'isSet1inSet2',
        ]),
        filtered_items() {
          if(this.type === 'spatial') {
            return this.$store.state.ProjectStructure.filter.spatial.objects.elements;
          } else {
            return this.$store.state.ProjectStructure.filter.process.objects.tworksteps;
          }
        },
        is_selected_result() {
          if (this.type === 'spatial') {
              return this.isSet1inSet2({
                  set1: { type: 'ids_by_target', value: { elements: this.filtered_items } },
                  set2: { type: 'collection_name', value: 'selected_elements' },
                  targets: ['elements'],
              }).result;
            } else {
            return this.isSet1inSet2({
                set1: { type: 'ids_by_target', value: { tworksteps: this.filtered_items } },
                set2: { type: 'collection_name', value: 'selected_steps' },
                targets: ['tworksteps'],
            }).result;
          }
        },
        is_visible_result() {
          if (this.type === 'spatial') {
            return this.isSet1inSet2({
                  set1: {type: 'ids_by_target', value: { elements: this.filtered_items } },
                  set2: {type: 'collection_name', value: 'visible_elements'},
                  targets: ['elements'],
              }).result;
            } else {
            return this.isSet1inSet2({
                  set1: {type: 'ids_by_target', value: { tworksteps: this.filtered_items } },
                  set2: {type: 'collection_name', value: 'visible_steps'},
                  targets: ['tworksteps'],
              }).result;
          }
        },
      },
      methods: {
        ...mapActions('ProjectStructure', [
        'toggleFilter',
        'updateSetting',
        'setCollectionObjects',
        ]),
        toggleFilterLocal(payload){
          this.toggleFilter(payload);
          if (this.type === 'spatial' && payload.value) {
            this.setCollectionObjects({ 
              action: 'set', 
              ids_by_target: {elements: this.filtered_items}, 
              collection_name: 'visible_elements' 
            });

            this.updateSetting({ type: 'wrapper', tree: 'spatial_tree', setting: 'show_empty_wrapper', value: false });
          }
          
          if (this.type === 'spatial' && !payload.value) {
            // console.log('TODO: set everything visible');
            this.setCollectionObjects({ 
              action: 'set', 
              ids_by_target: {elements: Object.keys(this.$store.state.Ultra.elements)}, 
              collection_name: 'visible_elements' 
            });

            this.updateSetting({ type: 'wrapper', tree: 'process_tree', setting: 'show_empty_wrapper', value: false });
          }

        },
        setSelectedCollection(){
          if (this.type === 'spatial') {
            this.setCollectionObjects({
                action: this.is_selected_result === 'complete' ? 'remove' : 'add',
                ids_by_target: {elements: this.filtered_items},
                collection_name: 'selected_elements', 
            });
          } else {
            this.setCollectionObjects({
                action: this.is_selected_result === 'complete' ? 'remove' : 'add',
                ids_by_target: {tworksteps: this.filtered_items},
                collection_name: 'selected_steps', 
            });
          }
        }
      }
    }
  </script>
  <style>
    .filter-header {
        width: 100%
    }
    .filter-header-row {
        display: flex;
    }
  </style>
  